import * as yup from 'yup'

export const validateCreateRankings = yup.object().shape({
    user_id: yup
    .number().typeError('Campo requerido.')
    .positive()
    .required('Campo requerido.'),
    product_id: yup
    .number().typeError('Campo requerido.')
    .positive()
    .required('Campo requerido.'),
    score: yup
    .number().typeError('Campo requerido.')
    .required('Campo requerido.')
    .positive()
    .min(1, 'Debe de utilizar un numero que no sea negativo'),
    message: yup
    .string()
    .required('Campo requerido.')
    .min(2, 'EL MENSAJE debe tener más de 1 caracteres'),
})